import React from 'react';
import styles from './Button.module.css';
import ButtonBase, {ButtonBaseProps} from './ButtonBase';

export default function ButtonClear({className, ...rest}: ButtonBaseProps) {
  return <ButtonBase className={`${styles.riseBtnClear} rise-btn-clear ${className ?? ''}`} {...rest} />;
}
